<ng-container>
  @if (!isOTPVerified) {
    <div>
      <div class="p-0 page-title flex-grow-1 ng-star-inserted">
        <div class="mb-0 ng-star-inserted">
          <div class="d-flex justify-content-between">
            <div class="pr-2 ng-star-inserted">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="backToPatientRegistration()">
                <img src="assets/images/grid-back.png">
              </a>
            </div>
            <div class="d-flex justify-content-between flex-grow-1">
              <div class="">
                <p class="m-0">{{'field.label.enter_otp_normal' | translate | async}}</p>
              </div>
              <p class="text-primary"><span>2/</span> <span style="font-size: 0.8em;">3</span></p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="top-heading mt-2">
      <h5 class="m-0">Enter verification code</h5>
    </div> -->
    <div class="mt-2">
      <!-- <p>We have sent you 6 digit verification code on your mobile to verify contact details.</p> -->
      <p>{{'field.label.Enter_OTP' | translate | async}}</p>
    </div>
    @if (showOtpComponent) {
      <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
      </app-otp-input>
    }
    <div class="col-12 p-0 mt-4">
      <button class="login-button btn-gradient button-hover text-white" (click)="verifyOtp()">
        {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
      aria-hidden="true"></i>
    </button>
  </div>
  <div class="col-12 mt-1 p-0">
    @if (!showTimer) {
      <span [ngClass] style="cursor: pointer;color: #20a8d8;"
      (click)="resendCode()">{{'field.label.resend_OTP' | translate | async}}</span>
    }
    @if (showTimer) {
      <span style="cursor: not-allowed; color: gray;">{{'field.label.resend_OTP' | translate |
      async}}</span>
    }
    @if (showTimer) {
      <span class="timer">
        {{timer}} sec
      </span>
    }
  </div>
</div>
}

@if (isOTPVerified && !headerInfo.skip_login_in) {
  <div>
    <div class="p-0 page-title flex-grow-1 ng-star-inserted">
      <div class="mb-0 ng-star-inserted">
        <div class="d-flex justify-content-between">
          <div class=" pr-2 ng-star-inserted">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="backToOtpVerify()">
              <img src="assets/images/grid-back.png">
            </a>
          </div>
          <div class="d-flex justify-content-between flex-grow-1">
            <div class="">
              <p class="m-0">Set Login ID & Password</p>
            </div>
            <p class="text-primary"><span>3/</span> <span style="font-size: 0.8em;">3</span></p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="top-heading mt-2">
    <h5 class="m-0">Set Login ID & Password</h5>
  </div> -->
  <div class="top-heading">
  </div>
  <form [formGroup]="form" (ngSubmit)="resetpassword()" class="mt-4" autocomplete="off">
    <!-- <div class="form-group"> -->
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
      <div class="floating-input-group c-mb-3">
        <input formControlName="login_id" id="login_id" type="text" class="form-control floating-input"
          minlength="4" maxlength="50" [ngClass]="{ 'is-invalid': submitted && f.login_id.errors }"
          autocomplete="new-password">
        <label for="login_id" class="floating-placeholder">{{'field.label.login_id' | translate |
        async}}</label>
        <!-- <div *ngIf="f.login_id.touched && f.login_id.invalid" class="alert alert-danger">
        <div *ngIf="f.login_id.errors.required">Login Id is required.</div>
      </div> -->
      @if (submitted && f.login_id.errors) {
        <div class="input-detail-error form-v2"
          [popover]="errorTemplate" triggers="mouseenter:mouseleave">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
      }
      <ng-template #errorTemplate>
        <div>
          @if (f.login_id.errors.required) {
            <div>Login Id is required</div>
          }
          @if (f.login_id.errors.minlength) {
            <div>Login Id requied atleast 4
              characters.
            </div>
          }
          @if (f.login_id.errors.maxlength) {
            <div>Login Id can not exceed 255
              characters.
            </div>
          }
        </div>
      </ng-template>
    </div>
  </div>
<!-- </div> -->
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
  <div class="floating-input-group c-mb-3">
    <input formControlName="password" id="password" type="{{eye != 'fa-eye'?'text':'password'}}"
      class="form-control floating-input" autocomplete="new-password"
      [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
    <label for="password" class="floating-placeholder">{{'field.label.password'| translate |
    async}}</label>
    @if (submitted && f.password.invalid) {
      <div class="input-detail-error form-v2" style="right: 30px;"
        [popover]="errorTemplate3" triggers="mouseenter:mouseleave">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </div>
    }
    <div class="input-group-append pass-eye-btn">
      <div class="input-group-text pass-eye">
        <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
          <i class="fa {{eye}}"></i>
        </span>
      </div>
    </div>
    <ng-template #errorTemplate3>
      <div>
        @if (f.password.errors.required) {
          <div>Password is required.</div>
        }
      </div>
    </ng-template>
  </div>
</div>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
  <div class="floating-input-group c-mb-3">
    <input formControlName="confirm_password" id="confirm_password"
      type="{{eye1 != 'fa-eye'?'text':'password'}}" class="form-control floating-input"
      autocomplete="new-password"
      [ngClass]="{ 'is-invalid': submitted && f.confirm_password.errors }">
    <label for="confirm_password" class="floating-placeholder">{{'field.label.confirm_password' |
    translate | async }}</label>
    @if (submitted && f.confirm_password.invalid) {
      <div style="right: 30px;"
        class="input-detail-error form-v2" [popover]="errorTemplate2" triggers="mouseenter:mouseleave">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </div>
    }
    <div class="input-group-append pass-eye-btn">
      <div class="input-group-text pass-eye">
        <span (click)="eye1=(eye1 == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
          <i class="fa {{eye1}}"></i>
        </span>
      </div>
    </div>
    <ng-template #errorTemplate2>
      <div>
        @if (f.confirm_password.errors.required) {
          <div>Password is required.</div>
        }
        @if (f.confirm_password.errors.confirmedValidator) {
          <div>Password and Confirm Password must
          be match.</div>
        }
      </div>
    </ng-template>
  </div>
</div>
<div class="col-12 p-0 mt-4">
  <button type="submit" class="login-button btn-gradient button-hover text-white">
    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
  aria-hidden="true"></i>
</button>
</div>
<div type="button" class="login-form-links mt-1 forgot-pass-login" (click)="skipRegistration()"><span class="cLink">Skip to Log-in</span></div>
</form>
</div>
}
</ng-container>